import * as React from 'react';
import {
  gaugeClasses,
  GaugeContainer,
  GaugeReferenceArc,
  GaugeValueArc,
} from '@mui/x-charts/Gauge';
import Typography from '@mui/material/Typography';
import { Box, Stack, useTheme } from '@mui/material';
import { IGaugePanel, ILabelValuePanel } from '../Dashboard.model';
import { LayoutItem } from 'react-grid-layout';
import LabelValuePanel from '../LabelValuePanel/LabelValuePanel';

interface GaugePanelProps {
  panel: IGaugePanel;
  layout?: LayoutItem | undefined;
}

export default function GaugePanel(props: GaugePanelProps) {
  const { panel, layout } = props;
  const { gaugeProps, icon, labelValueActive, labelValueInactive } = panel;
  const isSmall = layout ? layout?.w <= 2 || layout.h <= 1 || !icon : !icon; // Example condition for small size, adjust as needed
  const theme = useTheme();
  const chart = (
    <GaugeContainer
      {...gaugeProps}
      sx={{
        // make it look like the big donut
        [`& .${gaugeClasses.valueText}`]: {
          fontSize: 28,
          fontWeight: 800,
        },
        [`& .${gaugeClasses.valueArc}`]: {
          fill: theme.palette.success.main,
        },
        [`& .${gaugeClasses.referenceArc}`]: {
          fill: '#c0c0c0',
        },
      }}
    >
      <GaugeReferenceArc />
      <GaugeValueArc />

      {/* Main value */}
      <text x="50%" y="55%" textAnchor="middle" fontSize="28" fontWeight="bold">
        {gaugeProps?.value}
      </text>

      {/* Subtitle */}
      {isSmall && (
        <text x="50%" y="65%" textAnchor="middle" fontSize="9">
          {labelValueActive}
        </text>
      )}
    </GaugeContainer>
  );

  const content = isSmall ? (
    chart
  ) : (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      display={'flex'}
      height={'100%'}
      pb={1}
    >
      {/* Gauge block */}
      <Box
        sx={{
          height: 'calc(100% - 1em)',
          maxWidth: '100%',
          width: '100%',
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Simple */}
        {chart}
      </Box>
      {/* Legend */}
      <Stack direction="row" justifyContent="center" spacing={2} px={1}>
        {labelValueActive && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: theme.palette.success.main,
              }}
            />
            <Typography sx={{ fontSize: 12 }}>{labelValueActive}</Typography>
          </Stack>
        )}

        {labelValueInactive && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#c0c0c0',
              }}
            />
            <Typography sx={{ fontSize: 12 }}>{labelValueInactive}</Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
  const labelPanel: ILabelValuePanel = {
    ...panel,
    type: 'LABEL_VALUE',
    content: content,
  };

  return <LabelValuePanel panel={labelPanel} layout={layout} />;
}
